import Api from "api/base/axios.config";
import { UpdatePart, UpdateVehicle } from "./types";

const BASE_URL = "datamigration";
const TENANT_BASE_URL = "datamigrationtenant";

// Get Search Auth
export const getSearchAuth = async () => {
    const search = await Api.get(`${TENANT_BASE_URL}/algolia/auth`);
  
    return search.data;
  };

  export const getPart = async (partId: string, tenantId: string) => {
    
    const part = await Api.get(`${BASE_URL}/part?part_id=${partId}&tenant_id=${tenantId}`);
  
    return part.data;
  };

  export const getVehicle = async (vehicleId: string, tenantId: string) => {
    const vehicle = await Api.get(`${BASE_URL}/vehicle?vehicle_id=${vehicleId}&tenant_id=${tenantId}`);
  
    return vehicle.data;
  };

  export const updateVehicle = async (payload: UpdateVehicle) => {
    const vehicle = await Api.put(`${BASE_URL}/vehicle`, payload);
  
    return vehicle.data;
  };
  
  export const updatePart = async (payload: UpdatePart) => {
    const part = await Api.put(`${BASE_URL}/part`, payload);
  
    return part.data;
  };
  
